import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IFacility;

const facilitySlice = createSlice({
    name: "facility",
    initialState,
    reducers: {
        setFacility: (state, action: PayloadAction<IFacility | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setFacility } = facilitySlice.actions;
export default facilitySlice.reducer;

export const getFacility = (state: RootState) => state.facility;
